import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'recargas',
})
export class RecargasPipe implements PipeTransform {

  transform(items: any[], filter: string): any {

    console.log(items);

    return items.sort((a, b) => b[filter['orden']] - a[filter['orden']]);
  }

}



// WEBPACK FOOTER //
// ./src/pipes/recargas/recargas.ts